/* global graphql */

import React from 'react';
import Link from 'gatsby-link';

import Header from '../components/header';
import FeatureHeadline from '../components/headline';
import AvatarGrid from '../components/avatargrid';
import Maps from '../components/maps';

import ContentBlock from '../components/contentblock';
import ABBlock from '../components/contentblock/abblock'

import Mrt from '../resources/images/home/mrt.jpg';
import Mrt2x from '../resources/images/home/mrt@2x.jpg';

import Us from '../resources/images/home/ultraschall.jpg';
import Us2x from '../resources/images/home/ultraschall@2x.jpg';

import Dexa from '../resources/images/home/dexa.jpg';
import Dexa2x from '../resources/images/home/dexa@2x.jpg';

import Popup from '../components/popup';

const IndexPage = props =>
  (<main>
    <Header />
    <ABBlock compact img={Mrt} img2x={Mrt2x}>
      <ContentBlock title="MRT" link="/leistungen/mrt">
        Die Magnetresonanztomographie (kurz MRT) ist ein bildgebendes Verfahren, das vor allem in der medizinischen Diagnostik zur Darstellung von Struktur und Funktion der Gewebe und Organe im Körper eingesetzt wird.
      </ContentBlock>
    </ABBlock>
    <ABBlock compact right img={Us} img2x={Us2x}>
      <ContentBlock title="Ultraschall" link="/leistungen/ultraschall">
        Unter Ultraschall versteht man Schallwellen oberhalb der menschlichen Hörgrenze.
      </ContentBlock>
    </ABBlock>
    <ABBlock compact img={Dexa} img2x={Dexa2x}>
      <ContentBlock title="Knochendichtemessung" link="/leistungen/dexa">
        Als Knochendichtemessung, auch Dexamessung, werden medizinisch-technische Verfahren bezeichnet, die zur Bestimmung der Dichte bzw. des Kalksalzgehaltes des Knochens dienen.
      </ContentBlock>
    </ABBlock>
    <div className="text--block centered">
      <Link to="/leistungen" className="centered">
          Alle Leistungen anzeigen
      </Link>
    </div>
    <FeatureHeadline
      devices
      title="Moderne digitale Radiodiagnostik hat Vorteile für den Patienten und die Umwelt"
      linktitle="Unsere Geräte"
      link="/geraete"
      centered
      contained
    />
    <FeatureHeadline title="Keine Angst, unser Team kümmert sich um Sie" transparent light centered />
    <AvatarGrid/>
    <Maps/>
  </main>);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js